/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { GetTokenResponse } from '../models/response/get-token.response';
import { AgilcredBaseService } from './agilcred-base.service';
import { BehaviorSubject, lastValueFrom, mergeMap, Observable } from 'rxjs';
import { LoginResponse } from '../models/response/login.response';
import { DataService } from './data.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends AgilcredBaseService {
  private isLogged = new BehaviorSubject<boolean>(false);
  public isLogged$ = this.isLogged.asObservable();

  constructor(private dataService: DataService) {
    super();
  }
  setIsLogged(value: boolean): void {
    this.isLogged.next(value);
  }

  getIsLogged(): Observable<boolean> {
    return this.isLogged$;
  }

  loginWithCode(code: number, uuid: string): Observable<LoginResponse> {
    return this.dataService.getUserObservable().pipe(
      mergeMap(({ usuario }) => {
        const params = new HttpParams({ fromObject: { usuario } });
        return this.post<LoginResponse>('code-signin', { code: code.toString(), uuid }, params);
      }),
    );
  }

  getToken(): Promise<GetTokenResponse> {
    return lastValueFrom(this.post<GetTokenResponse>(`get-token`, null));
  }
}
